import type { Event } from '@patsnap/tahiti-core';
import type { EmbodimentRule, SelectedClaimFeature, SelectedKeyword } from '../types';

/**
 * 实施例规则服务
 * 用于管理实施例生成的规则配置
 */
export const EmbodimentRulesService = Symbol.for('EmbodimentRulesService');

export interface EmbodimentRulesService {
    /**
     * 状态变更事件
     * 当规则状态发生变化时触发
     */
    readonly onStateChange: Event<EmbodimentRule[]>;

    /**
     * 规则提交事件
     * 当规则被提交时触发
     */
    readonly onSubmitRules: Event<EmbodimentRule[]>;

    /**
     * 获取当前模型数据
     * @returns 规则列表
     */
    getModelData(): EmbodimentRule[];

    /**
     * 创建新规则
     */
    createRule(): void;

    /**
     * 删除指定规则
     * @param id - 规则ID
     */
    deleteRule(id: string): void;

    /**
     * 更新规则的特征
     * @param id - 规则ID
     * @param feature - 选中的权利要求特征
     */
    updateFeature(id: string, feature: SelectedClaimFeature): void;

    /**
     * 更新规则的关键词
     * @param id - 规则ID
     * @param keyword - 选中的关键词
     */
    updateKeyword(id: string, keyword: SelectedKeyword): void;

    /**
     * 批量更新规则
     * @param rules - 规则列表
     */
    updateRules(rules: EmbodimentRule[]): void;

    /**
     * 重置规则
     * 清空所有规则
     */
    resetRules(): void;

    /**
     * 提交规则
     * 触发规则提交事件
     */
    submitRules(): void;
}
